export const EVEREST_STAR_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@id": "https://everest.ind.br/#organization",
   "@type": "Organization",
   "name": "Everest",
   "url": "https://everest.ind.br",
   "logo": {
    "@type": "ImageObject",
    "url": "https://www.everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/produto/everest-star#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Produtos",
     "item": "https://everest.ind.br/pt/produto"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Purificador de Água Everest Star",
     "item": "https://everest.ind.br/pt/produto/everest-star"
    }
   ]
  },
  {
   "@type": "Product",
   "@id": "https://everest.ind.br/pt/produto/everest-star#product",
   "name": "Purificador de Água Everest Star",
   "description": "O purificador mais robusto da linha Everest, com refrigeração por compressor. Ideal para famílias grandes, escritórios e ambientes comerciais. Fornece água gelada, natural ou misturada para até 30 pessoas por hora. Armazenamento de 2 litros de água gelada. Instalação em bancada ou parede.",
   "url": "https://everest.ind.br/pt/produto/everest-star",
   "image": [
    "https://assets.everest.ind.br/images/Group_37297-min.original.original.png"
   ],
   "brand": {
    "@type": "Brand",
    "name": "Everest"
   },
   "manufacturer": {
    "@id": "https://everest.ind.br/#organization"
   },
   "model": "Everest Star",
   "mpn": "EVEREST-STAR",
   "category": "Casa > Purificador de Água",
   "color": "Branco, Preto, Prata, Cereja",
   "material": "Aço galvanizado, Polipropileno, Cobre, Poliuretano, Latão, Aço inoxidável",
   "audience": {
    "@type": "Audience",
    "audienceType": "Uso em escritório e uso residencial em ambientes de média demanda"
   },
   "additionalProperty": [
    {
     "@type": "PropertyValue",
     "name": "Sistema de refrigeração",
     "value": "Compressor"
    },
    {
     "@type": "PropertyValue",
     "name": "Temperatura média da água gelada",
     "value": "8°C"
    },
    {
     "@type": "PropertyValue",
     "name": "Capacidade de refrigeração",
     "value": "2 litros/hora (ambiente 32°C, água 27°C)"
    },
    {
     "@type": "PropertyValue",
     "name": "Armazenamento de água gelada",
     "value": "2 litros"
    },
    {
     "@type": "PropertyValue",
     "name": "Capacidade de atendimento",
     "value": "Até 30 pessoas por hora"
    },
    {
     "@type": "PropertyValue",
     "name": "Vida útil do refil",
     "value": "4.000 litros (9 a 12 meses)"
    },
    {
     "@type": "PropertyValue",
     "name": "Temperatura de trabalho",
     "value": "5°C a 42°C"
    },
    {
     "@type": "PropertyValue",
     "name": "Pressão da rede hidráulica",
     "value": "3 a 40 MCA (0,029 a 0,392 MPa)"
    },
    {
     "@type": "PropertyValue",
     "name": "Tensão",
     "value": "127V ou 220V – 60Hz"
    },
    {
     "@type": "PropertyValue",
     "name": "Consumo",
     "value": "100W"
    },
    {
     "@type": "PropertyValue",
     "name": "Instalação",
     "value": "Bancada ou Parede"
    },
    {
     "@type": "PropertyValue",
     "name": "Altura",
     "value": "39,5 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Largura",
     "value": "30,5 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Profundidade",
     "value": "37 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Peso",
     "value": "12 kg"
    },
    {
     "@type": "PropertyValue",
     "name": "Certificação",
     "value": "INMETRO, ABRAFIPA"
    }
   ],
   "offers": {
    "@type": "Offer",
    "priceCurrency": "BRL",
    "price": "1329.05",
    "availability": "https://schema.org/InStock",
    "url": "https://everest.ind.br/pt/produto/everest-star",
    "seller": {
     "@id": "https://everest.ind.br/#organization"
    }
   },
   "potentialAction": {
    "@type": "ViewAction",
    "target": "https://everest.ind.br/pt/produto/everest-star"
   }
  }
 ]
}
